define('areas/home/model/livetilerequest',["require", "exports"], function (require, exports) {
    "use strict";
    var LiveTileRequest = (function () {
        function LiveTileRequest() {
        }
        return LiveTileRequest;
    }());
    return LiveTileRequest;
});

